import * as accordion from "./accordion.js";
import * as bio from "./bio.js";
import * as cards from "./cards.js";
import * as carousel from "./carousel.js";
import * as collection from "./collection.js";
import * as contact from "./contact.js";
import * as cta from "./cta.js";
import * as divider from "./divider.js";
import * as filedown from "./filedown.js";
import * as fileprev from "./fileprev.js";
import * as gallery from "./gallery.js";
import * as group from "./group.js";
import * as heading from "./heading.js";
import * as hero from "./hero.js";
import * as image from "./image.js";
import * as imgtext from "./imgtext.js";
import * as link from "./link.js";
import * as links from "./links.js";
import * as quote from "./quote.js";
import * as reviews from "./reviews.js";
import * as social from "./social.js";
import * as spacer from "./spacer.js";
import * as stats from "./stats.js";
import * as text from "./text.js";
import * as tutorials from "./tutorials.js";
export const CORE_BLOCKS = {
  accordion,
  bio,
  cards,
  carousel,
  collection,
  contact,
  cta,
  divider,
  filedown,
  fileprev,
  gallery,
  group,
  heading,
  hero,
  image,
  imgtext,
  link,
  links,
  quote,
  reviews,
  social,
  spacer,
  stats,
  text,
  tutorials,
};
export const CORE_BLOCK_TYPES = Object.keys(CORE_BLOCKS);
